import { render, staticRenderFns } from "./StandForm.vue?vue&type=template&id=da277578"
import script from "./StandForm.vue?vue&type=script&lang=ts"
export * from "./StandForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports